export default __webpack_public_path__ + "static/media/random-lady.0fa73bf7.webp";